/**
 * OnboardingStep1.tsx - Personal Interests
 * First step of the onboarding flow.
 * Allows users to select interests (multi-select chip interface).
 * Uses design system utilities for consistent styling.
 */
import React from "react";
import { View, StyleSheet } from "react-native";
import OnboardingStepHeader from "./common/OnboardingStepHeader";
import ChipSelector, { ChipOption } from "../../common/form/ChipSelect/ChipSelector";
import CustomText from "../../common/general/CustomText/CustomText";
import { spacing } from "../../../styles/design-system";

export interface OnboardingStep1Props {
  selectedInterests: string[];
  onInterestsChange: (interests: string[]) => void;
}

const interestOptions: ChipOption[] = [
  { key: "video_games", value: "Video Games", icon: <CustomText text="🎮" size="m" useTranslationText={false} style={undefined} /> },
  { key: "sports", value: "Sports", icon: <CustomText text="🏀" size="m" useTranslationText={false} style={undefined} /> },
  { key: "music", value: "Music", icon: <CustomText text="🎵" size="m" useTranslationText={false} style={undefined} /> },
  { key: "cooking", value: "Cooking", icon: <CustomText text="🍳" size="m" useTranslationText={false} style={undefined} /> },
  { key: "art_design", value: "Art & Design", icon: <CustomText text="🎨" size="m" useTranslationText={false} style={undefined} /> },
  { key: "travel", value: "Travel", icon: <CustomText text="✈️" size="m" useTranslationText={false} style={undefined} /> },
  { key: "movies_tv", value: "Movies & TV", icon: <CustomText text="🎬" size="m" useTranslationText={false} style={undefined} /> },
  { key: "reading", value: "Reading", icon: <CustomText text="📚" size="m" useTranslationText={false} style={undefined} /> },
  { key: "fitness", value: "Fitness", icon: <CustomText text="💪" size="m" useTranslationText={false} style={undefined} /> },
  { key: "technology", value: "Technology", icon: <CustomText text="💻" size="m" useTranslationText={false} style={undefined} /> },
  { key: "nature", value: "Nature", icon: <CustomText text="🌿" size="m" useTranslationText={false} style={undefined} /> },
  { key: "animals_pets", value: "Animals & Pets", icon: <CustomText text="🐾" size="m" useTranslationText={false} style={undefined} /> },
];

function OnboardingStep1({ selectedInterests, onInterestsChange }: OnboardingStep1Props) {
  return (
    <View style={styles.container}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step1_title"
        subtitleKey="companion_onboarding_step1_subtitle"
      />
      <ChipSelector
        options={interestOptions}
        selectedKeys={selectedInterests}
        onSelectionChange={onInterestsChange}
        multiSelect
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: spacing.lg,
  },
});

export default OnboardingStep1;
